import PropTypes from 'prop-types';

export default function CircularCrossIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      id={`circularCrossIcon${props.id ? `__${props.id}` : ''}`}
    >
      <title>Circular Cross Icon</title>
      <path d={'M12,10.5857864 L9.17157288,7.75735931 L7.75735931,9.17157288 L10.5857864,12 L7.75735931,14.8284271 '
      + 'L9.17157288,16.2426407 L12,13.4142136 L14.8284271,16.2426407 L16.2426407,14.8284271 '
      + 'L13.4142136,12 L16.2426407,9.17157288 L14.8284271,7.75735931 L12,10.5857864 Z M12,20 '
      + 'C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 '
      + '16.418278,20 12,20 Z'}
      />
    </svg>
  );
}

CircularCrossIcon.propTypes = {
  id: PropTypes.string,
};
